import {tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetAdvertisingConfigurationUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   */
  constructor({repository}) {
    super({
      repository
    })

    this._repository = repository
  }

  /**
   * @return {Promise<Object, Error>} returns advertising configuration object
   */
  @tracer({metric: 'GetAdvertisingConfigurationUseCase#execute'})
  async execute() {
    return this._repository
      .getAdvertisingConfiguration()
      .then(advertisingConfiguration => advertisingConfiguration.toJSON())
  }
}
